// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__V3u8n","dragIcon":"SortableItem_dragIcon__2PDIW","disabled":"SortableItem_disabled__VW_uY"};